module.exports = __webpack_public_path__ + "static/media/word.d63d32e4.png";